import { MeProfile } from '@/core/services/profile/me-profile.model';
import { ProfileService } from '@/core/services/profile/profile.service';
import { HomeState } from '@/modules/home/core/state/home.state';
import { NotificacaoItem } from '@/modules/home/repository/home-notificacoes-item.types';
import { CommonModule } from '@angular/common';
import { Component, computed, inject, model, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { StyleClassModule } from 'primeng/styleclass';

interface NotificationsBars {
  id: string;
  label: string;
  badge?: string | any;
}

@Component({
  selector: 'cam-notifications-menu',
  standalone: true,
  templateUrl: './notifications-menu.component.html',
  styleUrl: './notifications-menu.component.scss',
  imports: [
    CommonModule,
    FormsModule,
    StyleClassModule,
    ButtonModule,
    IconFieldModule,
    InputIconModule,
    OverlayBadgeModule,
    AvatarModule,
    TranslateModule,
  ],
})
export class NotificationsMenuComponent {
  private readonly profileService = inject(ProfileService);

  private readonly store = inject(Store);
  router = inject(Router);
  readonly typeMap: Record<string, string> = {
    CAMERA_PANIC: 'Alerta',
    PERSONAL_PANIC: 'Pânico',
    PESSOAL: 'Pessoal',
    CAMERA_MOVEMENT: 'Movimento detectado',
    CAMERA_MOVEMENT_PORTAL: 'Movimento detectado',
    PERSON_DETECTION_v2: 'Pessoa detectada',
    OBJECT_DETECTION: 'Movimento detectado',
  };

  me = this.store.selectSignal<MeProfile>(HomeState.getMe);
  latestNotifications = this.store.selectSignal<any[]>(
    HomeState.getLatestNotifications,
  );

  notificationSearch = '';
  unreadNotificationsCount = this.store.selectSignal(
    HomeState.getUnreadNotificationsCount,
  );

  notificationsBars = signal<NotificationsBars[]>([
    {
      id: 'unread',
      label: 'Não Lidas',
      badge: computed(() => this.unreadNotificationsCount().toString()),
    },
    {
      id: 'read',
      label: 'Lidas',
    },
  ]);

  unreadNotifications = computed(() =>
    this.latestNotifications().filter((notification) => !notification.viewed),
  );

  readNotifications = computed(() =>
    this.latestNotifications().filter((notification) => notification.viewed),
  );

  selectedNotificationBar = model(this.notificationsBars()[0].id ?? 'unread');

  selectedNotificationsBarData = computed(() => {
    if (this.selectedNotificationBar() === 'unread') {
      return this.unreadNotifications();
    } else {
      return this.readNotifications();
    }
  });
  notificationPreference = computed(() => {
    return {
      pushAll: this.me()?.push_all ?? true,
      notifyConfig: this.me()?.notifyConfig,
    };
  });

  formatTime(dateString: string): string {
    const date = new Date(dateString);
    const now = new Date();
    const diffInHours = Math.floor(
      (now.getTime() - date.getTime()) / (1000 * 60 * 60),
    );

    if (diffInHours < 1) {
      const diffInMinutes = Math.floor(
        (now.getTime() - date.getTime()) / (1000 * 60),
      );
      return `${diffInMinutes} minuto${diffInMinutes !== 1 ? 's' : ''} atrás`;
    } else if (diffInHours < 24) {
      return `${diffInHours} hora${diffInHours !== 1 ? 's' : ''} atrás`;
    } else {
      const diffInDays = Math.floor(diffInHours / 24);
      return `${diffInDays} dia${diffInDays !== 1 ? 's' : ''} atrás`;
    }
  }

  getTipoExibicao(tipo: string): string {
    return this.typeMap[tipo] || tipo;
  }

  handleNotificationClick(notification: NotificacaoItem) {
    console.debug('Notificação clicada:', notification);
  }

  onNotifications(): void {
    this.router.navigate(['/notificacoes/detalhes']);
  }
}
